// 媒资类型
export const mediaTypeList = [
  {
    label: "其他",
    value: 0
  },
  {
    label: "电影",
    value: 1
  },
  {
    label: "电视剧",
    value: 2
  },
  {
    label: "动画片",
    value: 3
  },
  {
    label: "短剧",
    value: 4
  },
  {
    label: "电影票",
    value: 5
  },
  {
    label: "团购券",
    value: 6
  }
]

// 响应方式
export const skipTypeList = [
  {
    label: "无跳转",
    value: 0
  },
  {
    label: "详情页",
    value: 1
  },
  {
    label: "导流页",
    value: 2
  },
  {
    label: "分集feed流",
    value: 3
  },
  {
    label: "视频播放",
    value: 4
  }
]

export default safe => {
  console.log(safe); //vue的this对象
  return {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: true,
    // searchMenuSpan: 6,
    tree: true,
    border: true,
    /** 表格索引 */
    index: false,
    /** 表格搜索显隐按钮 */
    searchShowBtn: true,
    /** 是否启用功能按钮 */
    searchIcon: true,
    searchIndex: 0,
    /** 表格查看按钮 */
    viewBtn: false,
    /** 表格新增按钮 */
    addBtn: false,
    /** 表格删除按钮 */
    delBtn: false,
    /** 表格修改按钮 */
    editBtn: false,
    /** 多选 */
    // selection: true,
    /** 表格搜索按钮 */
    // searchBtn: false,
    /** 表格清空按钮 */
    // emptyBtn: false,
    /** 开启拖拽功能 */
    // sortable: true,
    // dragHandler: true,
    // rowSort: true,
    // columnSort: true,
    menuWidth: 200,
    column: [{
        label: "乐播媒资ID",
        prop: "id",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: true
      },
      {
        label: "媒资名称",
        prop: "name",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: true,
        slot: true
      },
      {
        label: "媒资来源",
        prop: "partnerName"
      },
      {
        label: "资源分类",
        prop: "module",
        dicData: [{
            label: "影视类",
            value: 1
          },
          {
            label: "平台类",
            value: 2
          }
        ]
      },
      //TODO:替换资源分类字段名
      {
        label: "媒资类型",
        prop: "type",
        dicData: mediaTypeList
      },
      // {
      //   label: "三方媒资ID",
      //   prop: "partnerMediaId"
      // },
      // {
      //   label: "媒资类型",
      //   prop: "typeLabel"
      // },
      {
        label: "响应方式",
        prop: "skipType",
        dicData: skipTypeList
      },
      {
        label: "付费模式",
        prop: "feeModeLabel"
      },
      {
        label: "媒资状态",
        prop: "statusLabel"
      },
      {
        label: "三方状态",
        prop: "partnerStatusLabel"
      },
      {
        label: "创建方式",
        prop: "addTypeLabel"
      },
      {
        label: "创建时间",
        prop: "addTime",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: true
      },
      // {
      //   label: "更新时间",
      //   prop: "updateTime",
      //   /** 当内容过长被隐藏时显示 tooltip */
      //   overHidden: true
      // },
      {
        label: "",
        prop: "my",
        hide: true,
        showColumn: false,
        search: true,
        display: false,
        menuClassName: "myClass",
        searchslot: true
      }
    ]
  };
  // return {
  //   title: '表格的标题',
  //   sortable: true,
  //   dragHandler: true,
  //   border: true,
  //   align: 'center',
  //   menuAlign: 'center',
  //   column: [
  //     {
  //       label: '姓名',
  //       prop: 'name'
  //     },
  //     {
  //       label: '性别',
  //       prop: 'sex'
  //     },
  //     {
  //       label: '日期',
  //       prop: 'date',
  //       type: 'date',
  //       format: 'yyyy-MM-dd hh:mm:ss',
  //       valueFormat: 'yyyy-MM-dd hh:mm:ss'
  //     }
  //   ]
  // };
};
